import React from 'react';

const Icon = ({ size = '48', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 48 48" fill="none" {...other}>
            <path
                d="M24 43.714c10.887 0 19.714-8.826 19.714-19.714 0-10.888-8.827-19.714-19.715-19.714C13.112 4.286 4.285 13.112 4.285 24c0 10.888 8.826 19.714 19.714 19.714Z"
                stroke="#18191B"
                strokeWidth="2.25"
            />

            <path
                d="M13.715 18.857 18.858 31.2 24 18.857 29.143 31.2l5.143-12.343"
                stroke="#18191B"
                strokeWidth="2.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
export default React.memo(Icon);
